import { BaseModel } from './BaseModel';

export class SSHKey extends BaseModel {
    public id = -1;
    public type = '';
    public fingerprint = '';
    public publicKey = '';
    public lastUsedAt: string | null = null;
    public createdAt: string | null = null;
}
